import React, { useEffect, useRef, useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { connect, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useHistory } from 'react-router-dom';
import { TFunction, useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import _AddEditSupplierDocument from './AddEditSupplierDocument';
import _DocumentTabel from './DocumentTabel';
import { BombiixModal } from '../../../Components/BombiixModal';
import { BombiixApprovalBar } from '../../../Components/BombiixApprovalBar';
import type { ApprovalOption, ApprovalSelectOption } from '../../../Components/BombiixApprovalBar/BombiixApprovalBar';
import {
  deleteDocument,
  getAllSupplersDocuments,
  approveRejectDocuments,
  unmountAction,
  getPendingDocumentType,
  getSupplierTemplates,
  getSupplierDocTemplates,
  archiveUnarchiveDocument,
  retrieveDocStatus as _retrieveDocStatus,
} from '../store/Supplier.action';
import { fetchUserDocumentsList } from '../../UserSetting/store/User.action';
import Loader from '../../../Components/Utility/Loader/Loader';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import { imageUrl, Page_Size as PAGE_SIZE } from '../../../Components/helper';
import EditSupplierTemplate from './EditSupplierTemplate';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import _DuplicateDocument from './DuplicateDocument';
import SupplierTabNav from '../SupplierTabNav';
import { Floaty, FloatyButton, FloatyGroup } from '../../../Components/Floaty';
import { AddIcon, DeleteIcon, ArchiveIcon, CloseIcon } from '../../../bombiix-icon';
import { NewSearch } from '../../../Components/PIM/common/NewSearch';
import { NewTextArea } from '../../../Components/PIM/common/NewTextArea';
import { NewBackButton } from '../../../Components/PIM/common/NewBackButton';
import { NewRadio } from '../../../Components/PIM/common/NewRadio';
import { NewSelectMultiSelect } from '../../../Components/PIM/common/NewSelectMultiSelect';
import { AppDispatch, useAppDispatch } from '../../../hooks/useAppDispatch';
import BombiixPreviewModal from '../../../Components/ModalPopup/BombiixPreviewModal';

type Fn<TArgs extends unknown[], TResult> = (...args: TArgs) => TResult;

type Thunk<TResult> = Fn<[dispatch: AppDispatch], Promise<TResult>>;
type CheckActionPermissionFn = Fn<[rights: unknown, section: string, module?: string, action?: string], boolean>;

/**
 * A supporting document or template row.
 */
interface SupportingDoc {
  [key: string]: unknown;
  _id: string;
  type?: string;
  title?: string;
  status?: string;
  s3Key?: string;
  documentType?: { _id?: string };
  factoryIds?: unknown;
}

type DocPage = SupportingDoc[] & { totalCount?: number };

interface DocumentStatus {
  [key: string]: unknown;
  name?: string;
  isActive?: boolean;
}

interface SupplierTemplateOption {
  _id: string;
  templateName?: string;
}

interface FetchDocsParams {
  pageIndex: number;
  pageSize: number;
  supplierId: string;
  supportingDocuments: SupportingDoc[];
  totalRecords: number | null | undefined;
  searchText?: string;
  sortOrder?: string;
  sortPropertyName?: string;
  isArchived?: boolean;
  isAllSelected?: boolean;
  selectedIdArray?: string[];
}

interface DocsQuery {
  pageIndex: number;
  pageSize: number;
  supplierId: string;
  isArchived: boolean;
  searchText?: string;
  sortOrder?: string;
  sortPropertyName?: string;
}

interface DocumentsPageState {
  supplierId: string;
  pageSize: number;
  pageIndex: number;
  sortOrder: string;
  sortPropertyName: string;
  searchText: string;
  searchLoaded: boolean;
  supportingDocuments: SupportingDoc[];
  hasMore: boolean;
  loading: boolean;
  totalRecords: number | null | undefined;
}

interface ArchiveState {
  archivedId: string | null;
  archiveComment: string;
  showArchivePopup: boolean;
  title?: string | string[] | undefined;
  documentType?: { _id?: string } | undefined;
  factoryId?: unknown;
  loading?: boolean;
  selectedIds?: string[];
}

interface ApprovalStatusPayload {
  status?: unknown;
  commentDate?: unknown;
  comment?: unknown;
}

type ApprovalTuple = [unknown, string[] | undefined, ApprovalStatusPayload | undefined];

interface EditDocumentState {
  data: SupportingDoc | null;
  id: string | null | undefined;
  index?: number | undefined;
}

interface AddEditDocumentState {
  isOpen: boolean;
  isEdit: boolean;
  isRenew: boolean;
  isTemplate: boolean;
  docId?: string | undefined;
}

interface OwnProps {
  match: { params: { supplierId: string } };
}

interface StateProps {
  isCompanyAdminLoggedIn: boolean | undefined;
  pendingDocumentType: string[];
  isCompanyUserLoggedIn: boolean | undefined;
}

interface DispatchProps {
  deleteDocumentId: Fn<[document: Record<string, unknown>, transactionMsg: TFunction<'modules/partner-overview'>], Promise<unknown>>;
  fetchUserDocumentsList: Fn<[data: { fromSupplier: string; supplierId: string }], Promise<unknown>>;
  getAllSupplersDocuments: Fn<[params: DocsQuery], Promise<{ data?: { doc?: DocPage | null } } | undefined>>;
  approveRejectDocuments: Fn<[document: Record<string, unknown>, transactionMsg: TFunction<'modules/partner-overview'>], Promise<unknown>>;
  unmountAction: () => Promise<unknown>;
  getPendingDocumentType: Fn<[params: { supplierId: string }], Promise<unknown>>;
  getSupplierTemplates: () => Promise<unknown>;
  fetchSupplierDocTemplates: Fn<[supplierId: string], Promise<unknown>>;
  archiveUnarchiveSupplierDocument: Fn<[details: Record<string, unknown>, transactionMsg: TFunction<'modules/partner-overview'>], Promise<unknown>>;
}

interface SuppliersDocumentsStoreState {
  Users: { logInRights?: unknown };
  SuppliersDetails: {
    supportingDocuments?: unknown;
    pendingDocumentType: string[];
    supplierTemplates?: SupplierTemplateOption[];
    documentTemplate?: Array<{ documentId?: string; templateId?: string }>;
  };
  UserDetails: { userInfo?: unknown; isCompanyAdminLoggedIn?: boolean; isCompanyUserLoggedIn?: boolean; isSupplierLoggedIn?: boolean };
}

type SuppliersDocumentsProps = OwnProps & StateProps & DispatchProps;

const DocumentTabel = _DocumentTabel as unknown as React.FC<{
  supplierId: string;
  handleSelectAll: () => void;
  supportingDocument: SupportingDoc[];
  selectDocumentCheckBox: Fn<[event: React.ChangeEvent<HTMLInputElement>, id: string, item: SupportingDoc], void>;
  allSelectedDocuments: boolean;
  Documents: string[];
  onDelete: Fn<[id: string, item: SupportingDoc], void>;
  onEdit: Fn<[event: React.SyntheticEvent | null, docId: string, index: number, item: SupportingDoc], void>;
  onDownload: Fn<[path: string], void>;
  onPreview: Fn<[doc: SupportingDoc], void>;
  onRenew: Fn<[event: React.SyntheticEvent | null, doc: SupportingDoc, id: string], void>;
  onSortColumn: Fn<[propertyName: string], void>;
  sortTable: { sortOrder: string; sortPropertyName: string };
  loading: boolean;
  CostingAddEditAccess: boolean;
  CostingDeleteAccess: boolean;
  archiveSection: boolean;
  handleArchiveCard: Fn<[id: string, item: SupportingDoc], void>;
  handleDuplicateById: Fn<[item: SupportingDoc], void>;
  handleApproveRejectDoc: Fn<[value: ApprovalTuple, fromClear?: boolean, data?: SupportingDoc], void>;
}>;

const AddEditSupplierDocument = _AddEditSupplierDocument as unknown as React.FC<{
  onOpen: boolean;
  toggle: () => void;
  isEditMode: boolean;
  isRenewMode: boolean;
  data: SupportingDoc | null;
  index: number | undefined;
  renewalData: { doc: SupportingDoc; id: string } | null;
  supplierId: string;
  refreshPage: () => void;
  updateSupplierDocument: () => void;
}>;

const DuplicateDocument = _DuplicateDocument as unknown as React.FC<{
  onOpen: boolean;
  toggle: () => void;
  data: SupportingDoc | null;
  index: number | undefined;
  supplierId: string;
  refreshPage: () => void;
}>;

const retrieveDocStatus = _retrieveDocStatus as unknown as Fn<[params: { docIds: Array<string | undefined> }], Thunk<DocumentStatus[] | null | undefined>>;

const DEBOUNCE_DELAY = 1000;

/**
 * Reads a configured document status's name out of the approval payload.
 * @param {unknown} status - The picked status option.
 * @returns {unknown} Its name, when it carries one.
 */
const statusName = (status: unknown): unknown => (status !== null && typeof status === 'object' && 'name' in status ? status.name : undefined);

/**
 * Supporting documents tab: the documents grid with upload / template add,
 * delete, archive, duplicate, renew and the single-document approval bar.
 *
 * The header button names the view you can switch TO: "Archive" while looking at
 * open documents, "Open" while looking at archived ones (Figma nodes
 * 12385:216034 / 216418). The approval bar docks at the bottom of the viewport
 * when exactly one document is ticked, so the Floaty lifts to clear it. Delete
 * and Archive both act on the current selection, so they share one recessed well
 * that greys out as a unit while nothing is selected (Figma node 12385:216095).
 *
 * A Template is approved or rejected outright; every other document takes one of
 * the company's configured statuses. The bar renders a segmented group for the
 * first and a status dropdown for the second, so only one of those two lists is
 * ever non-empty. The existing-document prompt uses the master-design modal so
 * the action is named on the button.
 * @param {object} props - Component props.
 * @returns {React.ReactElement} The documents tab.
 */
function SuppliersDocuments({
  deleteDocumentId,
  match,
  fetchUserDocumentsList: fetchUserDocumentsListProp,
  getAllSupplersDocuments: getAllSupplersDocumentsProp,
  approveRejectDocuments: approveRejectDocumentsProp,
  unmountAction: unmountActionProp,
  getPendingDocumentType: getPendingDocumentTypeProp,
  pendingDocumentType,
  getSupplierTemplates: getSupplierTemplatesProp,
  fetchSupplierDocTemplates,
  archiveUnarchiveSupplierDocument,
  isCompanyAdminLoggedIn,
  isCompanyUserLoggedIn,
}: SuppliersDocumentsProps) {
  const { supplierId } = match.params;
  const { t } = useTranslation('modules/partner-overview');
  const { t: tCommon } = useTranslation('common');
  const dispatch = useAppDispatch();
  const history = useHistory();
  const listInnerRef = useRef<HTMLDivElement | null>(null);
  const [Documents, setDocuments] = useState<string[]>([]);
  const [selectedDocType, setSelectedDocType] = useState<Array<string | undefined>>([]);
  const [selectedDocStatus, setSelectedDocStatus] = useState<DocumentStatus[]>([]);

  const [supportingDocument, setSupportingDocumnt] = useState<SupportingDoc[]>([]);
  const [previewDoc, setPreviewDoc] = useState(false);
  const [allSelectedDocuments, setAllSelectedDocuments] = useState(false);
  const [multipleSelectedDocuments, setMultipleSelectedDocuments] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [editDocument, setEditDocument] = useState<EditDocumentState>({
    data: null,
    index: -1,
    id: '',
  });
  const [documetListUpdate, setDocumetListUpdate] = useState(false);
  const [forRenewDocument, setForRenewDocument] = useState<{ doc: SupportingDoc; id: string } | null>(null);
  const [addEditDocumentOpen, setAddEditDocumentOpen] = useState<AddEditDocumentState>({
    isOpen: false,
    isEdit: false,
    isRenew: false,
    isTemplate: false,
  });
  const [selectedFileToPreview, setFileToPreview] = useState<SupportingDoc | null>(null);
  const [index, setIndex] = useState<string | null>(null);
  const [showLoaderInDelete, setShowLoaderInDelete] = useState(false);
  const [state, setState] = useState<DocumentsPageState>({
    supplierId,
    pageSize: PAGE_SIZE,
    pageIndex: 1,
    sortOrder: '',
    sortPropertyName: '',
    searchText: '',
    searchLoaded: false,
    supportingDocuments: [],
    hasMore: true,
    loading: true,
    totalRecords: null,
  });
  const [openModal, setOpenModal] = useState<string | false>(false);
  const [showExistingModal, setShowExistingModal] = useState(false);
  const [sortTable, setSortTable] = useState({
    sortOrder: '',
    sortPropertyName: '',
  });
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [templateOption, setTemplateOptions] = useState<SupplierTemplateOption[] | null>(null);
  const [duplicateData, setDuplicateData] = useState<{ isOpen: boolean; duplicateData: SupportingDoc | null; index?: number }>({
    isOpen: false,
    duplicateData: null,
  });
  const [keys, setKeys] = useState<string | null>(null);
  const [dropModal, setDropModal] = useState(false);
  const ProductTestingData = useSelector((redState: SuppliersDocumentsStoreState) => redState);
  const { Users, SuppliersDetails, UserDetails } = ProductTestingData;
  const { isSupplierLoggedIn } = UserDetails;
  const [debounceTimeout, setDebounceTimeout] = useState<ReturnType<typeof setTimeout> | null>(null);
  const [docId, setDocId] = useState<Array<string | undefined>>([]);

  const { supplierTemplates, documentTemplate } = SuppliersDetails;
  const { logInRights } = Users;
  const CheckActionPermission = useComponent().CheckActionPermission as unknown as CheckActionPermissionFn;

  const CostingAddEditAccess = CheckActionPermission(logInRights, 'supplierOverview', 'all', 'addEdit');
  const CostingDeleteAccess = CheckActionPermission(logInRights, 'supplierOverview', 'all', 'delete');

  const [archiveSection, setArchiveSection] = useState(false);
  const [pendingTypesDismissed, setPendingTypesDismissed] = useState(false);
  const [approvalValue, setApprovalValue] = useState<string | number | null>(null);
  const [approvalStatusType, setApprovalStatusType] = useState<ApprovalSelectOption | null>(null);
  const [approvalDate, setApprovalDate] = useState<Date | null>(null);
  const [approvalComment, setApprovalComment] = useState('');
  const [id, setId] = useState('');
  const [archievState, setArchieveState] = useState<ArchiveState>({
    archivedId: null,
    archiveComment: '',
    showArchivePopup: false,
  });
  useEffect(() => {
    if (supplierTemplates && supplierTemplates.length > 0 && !archiveSection) {
      const allTemplates = state?.supportingDocuments?.filter((elem) => elem?.type === 'Template').map((e) => e._id);
      const mainDocTemplateId = documentTemplate?.filter((elem) => allTemplates.includes(elem.documentId ?? '')).map((e) => e.templateId);
      if (mainDocTemplateId && mainDocTemplateId.length > 0) {
        const newTemplateList = supplierTemplates.filter((ele) => !mainDocTemplateId.includes(ele._id));
        setTemplateOptions(newTemplateList);
      } else {
        setTemplateOptions(supplierTemplates);
      }
    } else {
      setTemplateOptions([]);
    }
  }, [supplierTemplates, state?.supportingDocuments, documentTemplate]);

  const updateSupplierDocument = () => {
    setDocumetListUpdate(!documetListUpdate);
  };

  useEffect(() => {
    fetchSupplierDocTemplates(supplierId);
  }, [supplierId, fetchSupplierDocTemplates]);

  useEffect(() => {
    if (state.searchText === '') {
      const supObj = {
        supplierId,
      };
      getPendingDocumentTypeProp(supObj);
    }
  }, [documetListUpdate]);

  useEffect(() => {
    if (supportingDocument.length === Documents.length && supportingDocument.length > 0) {
      setAllSelectedDocuments(true);
    }
  }, [Documents]);

  useEffect(() => {
    return () => {
      unmountActionProp();
    };
  }, [unmountActionProp]);

  /**
   * Toggles one document's selection, keeping the selected types and document-type
   * ids in step. On untick, only the first occurrence of the type is removed.
   * @param {React.ChangeEvent<HTMLInputElement>} e - The checkbox change.
   * @param {string} docIdToToggle - The document id.
   * @param {SupportingDoc} type - The document row.
   */
  const selectDocumentCheckBox = async (e: React.ChangeEvent<HTMLInputElement>, docIdToToggle: string, type: SupportingDoc) => {
    let selectedItems = [...Documents];
    const selectedtype = [...selectedDocType];
    if (e.target.checked) {
      setDocuments([...selectedItems, docIdToToggle]);
      setSelectedDocType([...selectedtype, type?.type]);
      if (type?.documentType) {
        setDocId([...docId, type?.documentType?._id]);
      }
    } else {
      setAllSelectedDocuments(false);
      selectedItems = selectedItems.filter((item) => item !== docIdToToggle);
      setDocuments([...selectedItems]);
      if (type?.documentType) {
        const docIdIndex = docId.indexOf(type?.documentType?._id);
        setDocId(docId.filter((_item, position) => position !== docIdIndex));
      }
      const ind = selectedtype.indexOf(type?.type);
      if (ind > -1) {
        selectedtype.splice(ind, 1);
      }
      setSelectedDocType([...selectedtype]);
    }
  };

  useEffect(() => {
    if (Documents.length > 0) {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }
      const newTimeout = setTimeout(async () => {
        if (selectedDocType.length > 0 && selectedDocType.includes('Document')) {
          const res = await dispatch(retrieveDocStatus({ docIds: docId }));
          if (res) {
            setSelectedDocStatus(res);
          }
        }
      }, DEBOUNCE_DELAY);

      setDebounceTimeout(newTimeout);
    }
  }, [Documents, selectedDocType]);

  const handleSelectAllDocuments = () => {
    if (allSelectedDocuments) {
      setDocuments([]);
      setSelectedDocType([]);
      setDocId([]);
    } else {
      const selectedItems = [...Documents];
      const selectedType = [...selectedDocType];
      const selectedIds = [...docId];
      supportingDocument.forEach((item) => {
        const findItem = selectedItems.filter((val) => val === item._id);
        if (findItem.length === 0) {
          selectedItems.push(item._id);
          selectedType.push(item?.type);
          selectedIds.push(item?.documentType?._id);
        }
      });
      setDocuments(selectedItems);
      setSelectedDocType(selectedType);
      setDocId(selectedIds.filter((val) => val !== undefined));
    }
    setAllSelectedDocuments(!allSelectedDocuments);
  };
  const closeConfirmationsPopup = () => {
    setShowConfirmationPopup(false);
    setIndex(null);
    setKeys(null);
  };

  const closeExistingConfirmationsPopup = () => {
    setOpenModal(false);
    setShowExistingModal(false);
    setAddEditDocumentOpen((prev) => ({
      ...prev,
      isOpen: false,
    }));
  };

  const DeletConfirmation = (i: string, item: SupportingDoc) => {
    setMultipleSelectedDocuments(false);
    setShowConfirmationPopup(!showConfirmationPopup);
    setIndex(i);
    setKeys(item?.s3Key || null);
  };

  const handleMultipleDelete = () => {
    setMultipleSelectedDocuments(true);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const DownloadDocument = (path: string) => {
    window.open(`${imageUrl}/static/${path}`);
  };

  const PreviewDocument = (doc: SupportingDoc) => {
    setFileToPreview(doc);
    setPreviewDoc(true);
  };

  const ExistingDocument = () => {
    setShowExistingModal(true);
  };

  const RenewDocument = (event: React.SyntheticEvent | null, doc: SupportingDoc, renewId: string) => {
    if (!showExistingModal) {
      ExistingDocument();
    }
    setOpenModal(doc?.type || 'Document');
    if (event) event.preventDefault();
    if (renewId !== null || renewId !== undefined) {
      setId(renewId);
      setForRenewDocument({ doc, id: renewId });
    }
  };

  const EditDocumentOpenClose = (event?: React.SyntheticEvent | null, editDocId?: string, editIndex?: number, item?: SupportingDoc) => {
    setOpenModal(item?.type || 'Document');
    if (event) event.preventDefault();
    setAddEditDocumentOpen((prev) => ({
      ...prev,
      isOpen: !prev.isOpen,
      isEdit: !!(editDocId !== null && editDocId !== undefined),
      isRenew: false,
      docId: editDocId,
    }));
    let editData: EditDocumentState = { data: null, id: null };
    if (editDocId !== null && editDocId !== undefined) {
      const data = state.supportingDocuments.filter((ele) => ele._id === editDocId);
      if (data?.length > 0 && data[0]) {
        editData = { data: data[0], id: editDocId, index: editIndex };
      }
    }
    setEditDocument(editData);
    setSelectedOption(null);
  };

  const toggleDuplicateData = () => {
    setDuplicateData((prev) => ({
      ...prev,
      isOpen: false,
      duplicateData: null,
    }));
  };

  /**
   * Loads one page of documents and appends it to what is already shown. Stops
   * paging once everything the server reported has been loaded.
   * @param {FetchDocsParams} data - Paging, sort, search and selection state.
   */
  const fetchAllSuppliers = async (data: FetchDocsParams) => {
    if (data.totalRecords !== null && data.totalRecords !== undefined && data.supportingDocuments.length >= data.totalRecords) {
      setState((prevState) => ({
        ...prevState,
        hasMore: false,
      }));
      return;
    }

    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));
    const params: DocsQuery = {
      pageIndex: data.pageIndex,
      pageSize: data.pageSize,
      supplierId: data.supplierId,
      isArchived: archiveSection,
    };
    if (data.searchText) {
      params.searchText = data.searchText;
    }

    if (data.sortOrder && data.sortPropertyName) {
      params.sortOrder = data.sortOrder;
      params.sortPropertyName = data.sortPropertyName;
    }
    const res = await getAllSupplersDocumentsProp(params);
    fetchSupplierDocTemplates(supplierId);

    const resDoc = res?.data?.doc || null;
    setState((prevState) => ({
      ...prevState,
      supportingDocuments: resDoc ? [...data.supportingDocuments, ...resDoc] : [],
      pageIndex: data.pageIndex + 1,
      loading: false,
      totalRecords: resDoc ? resDoc?.totalCount : 0,
    }));

    if (data.isAllSelected) {
      const selectedItems = [...(data.selectedIdArray ?? [])];
      const newDocId = Array.isArray(resDoc) ? resDoc.map((item) => item._id) : [];
      setDocuments([...selectedItems, ...newDocId]);
    }

    if (resDoc) {
      await setSupportingDocumnt([...data.supportingDocuments, ...resDoc]);
    }
  };

  const onSortColumn = async (propertyName: string) => {
    let sortObj = { sortOrder: '', sortPropertyName: '' };
    if (sortTable.sortOrder === '' || sortTable.sortOrder === 'Desc') {
      sortObj = {
        sortOrder: 'Asc',
        sortPropertyName: propertyName,
      };
    } else {
      sortObj = {
        sortOrder: 'Desc',
        sortPropertyName: propertyName,
      };
    }
    setSortTable(sortObj);
    const params = {
      ...sortObj,
      supplierId,
      pageSize: state.pageSize,
      pageIndex: 1,
      searchText: state.searchText,
      supportingDocuments: [],
      totalRecords: undefined,
    };
    await fetchAllSuppliers(params);
  };

  const handleSearch = async (e: { target: { value: string } }) => {
    const targetValue = e.target.value;
    setState((prevState) => ({
      ...prevState,
      searchText: targetValue,
      searchLoaded: true,
    }));
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event.target.id);

    if (event.target.id === 'upload') {
      EditDocumentOpenClose();
    } else {
      getSupplierTemplatesProp();
      setDropModal(true);
    }
  };

  const refreshPage = async () => {
    setState((prevState) => ({
      ...prevState,
      loading: true,
      pageIndex: 1,
      supportingDocuments: [],
      totalRecords: null,
      hasMore: true,
      searchLoaded: false,
    }));
    const params = {
      pageIndex: 1,
      pageSize: state.pageSize,
      supportingDocuments: [],
      totalRecords: null,
      searchText: state.searchText,
      supplierId: state.supplierId,
    };
    await fetchAllSuppliers(params);
  };

  const getAllSuppliersList = async () => {
    const params = {
      pageIndex: 1,
      pageSize: state.pageSize,
      totalRecords: state.totalRecords,
      supportingDocuments: [],
      supplierId: state.supplierId,
      searchText: state.searchText,
      sortOrder: sortTable.sortOrder,
      sortPropertyName: sortTable.sortPropertyName,
      isArchived: archiveSection,
    };
    await fetchAllSuppliers(params);
  };

  /**
   * Deletes the ticked documents that are still pending; approved or rejected ones
   * are locked, so they are named in a toast instead.
   */
  const handleMultiDelete = async () => {
    const selectedDocuments = state?.supportingDocuments.filter((doc) => Documents.includes(doc._id));
    const pendingDocumentsObjs = selectedDocuments.filter((doc) => doc.status === 'Pending');
    const pendingDocuments = pendingDocumentsObjs.map((doc) => doc._id);
    const approvedDocuments = selectedDocuments.filter((doc) => doc.status === 'Approved' || doc.status === 'Rejected').map((doc) => doc.title);

    if (pendingDocuments.length > 0) {
      const document = {
        supplierId,
        docIds: pendingDocuments,
        keys: pendingDocumentsObjs.map((doc) => ({ Key: doc?.s3Key || null })),
      };
      const res = await deleteDocumentId(document, t);
      if (res === 200) {
        clearDocumentSelection();
        refreshPage();
      }
      setShowLoaderInDelete(false);
    }
    if (approvedDocuments.length > 0) {
      toasterMsg(`${approvedDocuments.join(', ')} ${t('SUPPLIER_DOCUMENT.DOCUMENT_LOCKED')}`, 'danger');
    }
  };

  const deleteDocumentConfirmed = async () => {
    setShowLoaderInDelete(true);
    if (multipleSelectedDocuments) {
      handleMultiDelete();
    } else {
      const document = {
        supplierId,
        docIds: [index],
        keys: [keys]?.map((value) => ({ Key: value })),
      };
      const res = await deleteDocumentId(document, t);
      if (res === 200) {
        clearDocumentSelection();
        refreshPage();
      }
      setShowLoaderInDelete(false);
    }

    setShowConfirmationPopup(!showConfirmationPopup);
    updateSupplierDocument();
  };

  const handleApproveRejectDoc = async (value: ApprovalTuple, fromClear?: boolean, data?: SupportingDoc) => {
    let document;
    if (!fromClear) {
      let approvalStatus: unknown;
      if (selectedDocType?.includes('Template')) {
        approvalStatus = value[2]?.status === '1' ? 'Approved' : 'Rejected';
      } else {
        approvalStatus = statusName(value[2]?.status);
      }
      document = {
        supplierId,
        docIds: value[1],
        status: approvalStatus,
        commentDate: value[2]?.commentDate,
        comment: value[2]?.comment,
      };
    } else {
      document = {
        supplierId,
        docIds: [data?._id],
        status: 'Pending',
      };
    }

    const res = await approveRejectDocumentsProp(document, t);
    if (res === 200) {
      clearDocumentSelection();
      getAllSuppliersList();
    }
  };

  const handleNextPagesInScroll = async () => {
    const params = {
      pageIndex: state.pageIndex,
      pageSize: state.pageSize,
      searchText: state.searchText,
      supportingDocuments: state.supportingDocuments,
      totalRecords: state.totalRecords,
      sortOrder: sortTable.sortOrder,
      sortPropertyName: sortTable.sortPropertyName,
      supplierId: state.supplierId,
      isAllSelected: allSelectedDocuments,
      selectedIdArray: Documents,
      isArchived: archiveSection,
    };

    await fetchAllSuppliers(params);
  };

  const fetchDocumentsDropDownList = async () => {
    const data = { fromSupplier: 'true', supplierId };
    await fetchUserDocumentsListProp(data);
  };

  useEffect(() => {
    getAllSuppliersList();
    if (!archiveSection) {
      fetchDocumentsDropDownList();
    }
  }, [archiveSection]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        setState((prevState) => ({
          ...prevState,
          loading: true,
          pageIndex: 1,
          supportingDocuments: [],
          totalRecords: null,
          hasMore: true,
        }));
        const params = {
          pageIndex: 1,
          pageSize: state.pageSize,
          searchText: state.searchText,
          supportingDocuments: [],
          totalRecords: null,
          sortOrder: sortTable.sortOrder,
          sortPropertyName: sortTable.sortPropertyName,
          supplierId: state.supplierId,
          isArchived: archiveSection,
        };
        await fetchAllSuppliers(params);
        setState((prevState) => ({
          ...prevState,
          loading: false,
        }));
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [state.searchText]);

  const handleSelectTemplateChange = async (selected: SupplierTemplateOption) => {
    if (isSupplierLoggedIn) {
      history.push(`/settings/supporting-docs/edit/${supplierId}/template/${selected._id}?from=document`);
      setSelectedOption(null);
    } else {
      history.push(`/supplier/${supplierId}/templates/edit/${selected._id}?from=document`);
      setSelectedOption(null);
    }
  };

  const togglePreview = async () => {
    setFileToPreview(null);
    setPreviewDoc(false);
  };

  const handleArchiveCard = (ids: string, item: SupportingDoc) => {
    setArchieveState((prev) => ({
      ...prev,
      showArchivePopup: true,
      archivedId: ids,
      title: item.title,
      documentType: item?.documentType,
      factoryId: item?.factoryIds,
    }));
  };

  const toggleArchive = () => {
    setArchieveState((prev) => ({
      ...prev,
      loading: false,
      showArchivePopup: false,
      archivedId: null,
      archiveComment: '',
      title: '',
      selectedIds: [],
    }));
  };

  const conformArchive = async () => {
    setArchieveState((prev) => ({
      ...prev,
      loading: true,
    }));
    let archiveCardDetails = {};
    if (archievState?.archivedId === null) {
      const titles = Documents.map((eleId) => {
        const doc = state?.supportingDocuments?.find((item) => item._id === eleId);
        return doc ? doc.title : null;
      }).filter((title) => title !== null);
      archiveCardDetails = {
        isArchived: !archiveSection,
        archiveComment: archiveSection ? '' : archievState?.archiveComment,
        documentId: Documents,
        title: titles,
        section: 'supplierOverview',
        action: 'addEdit',
      };
    } else {
      archiveCardDetails = {
        documentId: [archievState?.archivedId],
        isArchived: !archiveSection,
        archiveComment: archiveSection ? '' : archievState?.archiveComment,
        title: archievState?.title,
        section: 'supplierOverview',
        action: 'addEdit',
        documentType: archievState?.documentType?._id,
        factoryId: archievState?.factoryId,
        supplierId,
      };
    }
    const res = await archiveUnarchiveSupplierDocument({ ...archiveCardDetails }, t);
    if (res) {
      toggleArchive();
      refreshPage();
      clearDocumentSelection();
    } else {
      setArchieveState((prev) => ({ ...prev, loading: false }));
    }
  };

  const archiveCommentChanges = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setArchieveState((prev) => ({
      ...prev,
      archiveComment: e?.target?.value,
    }));
  };

  const handleMultiArchiveCard = () => {
    setArchieveState((prev) => ({
      ...prev,
      showArchivePopup: true,
      archivedId: null,
    }));
  };

  const handleDuplicateById = (item: SupportingDoc) => {
    setDuplicateData((prev) => ({
      ...prev,
      isOpen: true,
      duplicateData: item,
    }));
  };

  const approvalOptions: ApprovalOption[] = selectedDocType?.includes('Template')
    ? [
        { label: tCommon('APPROVE_REJECT_FOOTER.APPROVED'), value: '1', variant: 'green' },
        { label: tCommon('APPROVE_REJECT_FOOTER.REJECTED'), value: '0', variant: 'red' },
      ]
    : [];

  const docStatusOptions: ApprovalSelectOption[] = (selectedDocStatus ?? [])
    .filter((entry) => entry?.isActive)
    .map((entry) => ({ label: entry?.name ?? '', value: entry?.name ?? '', ...entry }));

  /**
   * Hands the bar's state to the existing approve/reject call in the shape it
   * already expects, so the endpoint contract is unchanged by the restyle.
   * @returns {void}
   */
  const handleApprovalBarSave = () => {
    handleApproveRejectDoc([
      null,
      Documents,
      {
        status: selectedDocType?.includes('Template') ? approvalValue : approvalStatusType,
        commentDate: approvalDate,
        comment: approvalComment,
      },
    ]);
    setApprovalValue(null);
    setApprovalStatusType(null);
    setApprovalDate(null);
    setApprovalComment('');
  };

  const isApprovalBarOpen = Documents.length === 1 && !archiveSection && (isCompanyAdminLoggedIn || isCompanyUserLoggedIn) && CostingAddEditAccess;

  /**
   * Resets every piece of selection state together, so the next ticked document
   * looks up its statuses and approval options on its own.
   * @returns {void}
   */
  function clearDocumentSelection(): void {
    setDocuments([]);
    setSelectedDocType([]);
    setDocId([]);
    setAllSelectedDocuments(false);
  }

  const hasSelectionActions = CostingDeleteAccess || (CostingAddEditAccess && !archiveSection);

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">{t('SUPPLIER_DOCUMENTS.TITLE')}</h4>
        </div>
        <div className="action-icons-container">
          <NewSearch
            className="bombiix-search"
            value={state?.searchText ?? ''}
            onChange={(value) => handleSearch({ target: { value } })}
            placeholder={t('SUPPLIER_OVERVIEW.SEARCH_SUPPORTINGDOCUMENT')}
            width={200}
          />
          <button type="button" className="bombiix-btn btn-dark supplier-docs-archive-toggle" onClick={() => setArchiveSection(!archiveSection)}>
            {archiveSection ? t('PARTNER_OVERVIEWS.OPEN') : t('SUPPLIER_DOCUMENTS.ARCHIVE')}
          </button>
          <NewBackButton onBack={() => history.push('/suppliers')} />

          <div className="break" />
        </div>
      </div>
      <Floaty position={isApprovalBarOpen ? 'fixed-raised' : 'fixed'}>
        {!archiveSection && CostingAddEditAccess && (
          <OverlayTrigger
            placement="top"
            trigger="click"
            rootClose
            overlay={
              <Popover id="supplier-documents-add" className="bombiix-info-popover">
                <Popover.Content>
                  <div className="supplier-doc-add-menu">
                    <div className="supplier-doc-add-menu__options">
                      <NewRadio
                        name="add_doc"
                        id="upload"
                        label={t('SUPPLIER_DOCUMENT.UPLOAD')}
                        checked={selectedOption === 'upload'}
                        onChange={handleCheckboxChange}
                      />
                      <NewRadio
                        name="add_doc"
                        id="template"
                        label={t('SUPPLIER_DOCUMENT.TEMPLATE')}
                        checked={selectedOption === 'template'}
                        onChange={handleCheckboxChange}
                      />
                    </div>
                    {dropModal && (
                      <NewSelectMultiSelect<SupplierTemplateOption>
                        placeholder={t('SUPPLIER_DOCUMENT.SELECT_TEMPLATE')}
                        options={templateOption ?? []}
                        getOptionLabel={({ templateName }: SupplierTemplateOption) => `${templateName}`}
                        getOptionValue={({ _id }: SupplierTemplateOption) => `${_id}`}
                        onChange={(selected: unknown) => handleSelectTemplateChange(selected as SupplierTemplateOption)}
                      />
                    )}
                  </div>
                </Popover.Content>
              </Popover>
            }
          >
            <FloatyButton icon={AddIcon} label={tCommon('COMMON_LABEL.ADD')} showTooltip={false} />
          </OverlayTrigger>
        )}
        {hasSelectionActions && (
          <FloatyGroup disabled={!Documents.length}>
            {CostingDeleteAccess && <FloatyButton icon={DeleteIcon} variant="red" label={tCommon('COMMON_LABEL.DELETE')} onClick={handleMultipleDelete} />}
            {CostingAddEditAccess && !archiveSection && (
              <FloatyButton icon={ArchiveIcon} label={tCommon('COMMON_LABEL.ARCHIVE')} onClick={() => handleMultiArchiveCard()} />
            )}
          </FloatyGroup>
        )}
      </Floaty>

      <SupplierTabNav
        inlineContent={
          pendingDocumentType.length > 0 && !pendingTypesDismissed ? (
            <div className="pending-documents-banner ml-8" title={pendingDocumentType.join(', ')}>
              <span className="pending-documents-banner__label">{t('SUPPLIER_DOCUMENTS.PENDING_DOCUMENTS')}</span>
              <span className="pending-documents-banner__types">{pendingDocumentType.join(', ')}</span>
              <button
                type="button"
                className="pending-documents-banner__dismiss"
                aria-label={tCommon('COMMON_LABEL.CLOSE')}
                onClick={() => setPendingTypesDismissed(true)}
              >
                <CloseIcon size={16} />
              </button>
            </div>
          ) : null
        }
      />

      <div className="container-fluid py-4">
        <div id="scrollableDiv_PIM" className="supplier-documents-scroll" ref={listInnerRef}>
          <InfiniteScroll
            dataLength={state.supportingDocuments.length}
            next={() => {
              handleNextPagesInScroll();
            }}
            hasMore={state.hasMore}
            loader={state.loading && <Loader />}
            scrollableTarget="scrollableDiv"
          >
            <DocumentTabel
              supplierId={supplierId}
              handleSelectAll={handleSelectAllDocuments}
              supportingDocument={state.supportingDocuments}
              selectDocumentCheckBox={selectDocumentCheckBox}
              allSelectedDocuments={allSelectedDocuments}
              Documents={Documents}
              onDelete={DeletConfirmation}
              onEdit={EditDocumentOpenClose}
              onDownload={DownloadDocument}
              onPreview={PreviewDocument}
              onRenew={RenewDocument}
              onSortColumn={onSortColumn}
              sortTable={sortTable}
              loading={false}
              CostingAddEditAccess={CostingAddEditAccess}
              CostingDeleteAccess={CostingDeleteAccess}
              archiveSection={archiveSection}
              handleArchiveCard={handleArchiveCard}
              handleDuplicateById={handleDuplicateById}
              handleApproveRejectDoc={handleApproveRejectDoc}
            />
          </InfiniteScroll>
        </div>
      </div>
      {addEditDocumentOpen.isOpen && openModal === 'Document' ? (
        <AddEditSupplierDocument
          onOpen={addEditDocumentOpen.isOpen}
          toggle={EditDocumentOpenClose}
          isEditMode={addEditDocumentOpen.isEdit}
          isRenewMode={addEditDocumentOpen.isRenew}
          data={editDocument.data}
          index={editDocument.index}
          renewalData={forRenewDocument}
          supplierId={supplierId}
          refreshPage={refreshPage}
          updateSupplierDocument={updateSupplierDocument}
        />
      ) : (
        <EditSupplierTemplate
          onOpen={addEditDocumentOpen.isOpen}
          toggle={EditDocumentOpenClose}
          data={editDocument.data}
          supplierId={supplierId}
          refreshPage={refreshPage}
        />
      )}
      {duplicateData.isOpen && (
        <DuplicateDocument
          onOpen={duplicateData.isOpen}
          toggle={toggleDuplicateData}
          data={duplicateData.duplicateData}
          index={duplicateData.index}
          supplierId={supplierId}
          refreshPage={refreshPage}
        />
      )}
      {previewDoc && selectedFileToPreview && (
        <BombiixPreviewModal onOpen={previewDoc} data={selectedFileToPreview} moduleName="specTemplate" toggle={togglePreview} />
      )}
      <BombiixModal
        show={showConfirmationPopup}
        size="sm"
        title={t('SUPPLIER_DOCUMENTS.DELETE_CONFIRMATION_TITLE')}
        onClose={closeConfirmationsPopup}
        onSave={() => deleteDocumentConfirmed()}
        saveLabel={tCommon('COMMON_LABEL.DELETE')}
        saveVariant="red"
        saveLoading={showLoaderInDelete}
      >
        <div className="bombiix-modal__confirm-body">
          <p className="mb-0 text-center">{t('PARTNER_OVERVIEW.DELETE_MESSAGE')}</p>
        </div>
      </BombiixModal>
      {showExistingModal && (
        <BombiixModal
          show={showExistingModal}
          title={t('SUPPLIER_DOCUMENTS.EXISTING_CONFIRMATION_TITLE')}
          onClose={closeExistingConfirmationsPopup}
          onSave={() => {
            setShowExistingModal(false);
            if (id !== null || id !== undefined) {
              setAddEditDocumentOpen((prev) => ({
                ...prev,
                isOpen: true,
                isEdit: false,
                isRenew: true,
              }));
            }
          }}
          saveLabel={t('SUPPLIER_DOCUMENTS.RENEW')}
          size="sm"
          className="doc-existing-modal"
        >
          <p className="doc-existing-modal__message">{t('SUPPLIER_DOCUMENTS.DELETE_MESSAGE')}</p>
        </BombiixModal>
      )}
      {archievState?.showArchivePopup && (
        <BombiixModal
          show={archievState?.showArchivePopup}
          title={archiveSection ? t('PARTNER_OVERVIEW.UNARCHIVE_DOCUMENT_TITLE') : t('PARTNER_OVERVIEW.ARCHIVE_DOCUMENT_TITLE')}
          onClose={toggleArchive}
          onSave={conformArchive}
          saveLabel={archiveSection ? t('PARTNER_OVERVIEW.UNARCHIVE') : t('PARTNER_OVERVIEW.ARCHIEVE')}
          saveLoading={Boolean(archievState?.loading)}
          size="md"
        >
          <p className="mb-16 text-center">
            {archiveSection ? t('PARTNER_OVERVIEW.UNARCHIVE_DOCUMENT_CONFIRM') : t('PARTNER_OVERVIEW.ARCHIVE_DOCUMENT_CONFIRM')}
          </p>
          {archiveSection && <p className="mb-16 text-center">{t('PARTNER_OVERVIEW.UNARCHIVE_MESSAGE')}</p>}
          {!archiveSection && (
            <NewTextArea
              rows={3}
              resize="vertical"
              label={tCommon('CONFIRMATION_POPUP.COMMENT_LABEL')}
              value={archievState?.archiveComment}
              placeholder={tCommon('CONFIRMATION_POPUP.ENTER_COMMENT')}
              onChange={archiveCommentChanges}
            />
          )}
        </BombiixModal>
      )}
      {isApprovalBarOpen && (
        <BombiixApprovalBar
          className="bombiix-approval-bar--fixed"
          options={approvalOptions}
          value={approvalValue}
          onChange={setApprovalValue}
          showStatusType={!selectedDocType?.includes('Template')}
          statusTypeOptions={docStatusOptions}
          statusType={approvalStatusType}
          onStatusTypeChange={setApprovalStatusType}
          statusTypePlaceholder={t('SUPLIER.ADD_EDIT_SUPPLIER_OVERVIEW.SELECT_STATUS')}
          showDatePicker
          date={approvalDate}
          onDateChange={setApprovalDate}
          showComment
          showCommentCounter
          comment={approvalComment}
          onCommentChange={setApprovalComment}
          commentPlaceholder={tCommon('APPROVE_REJECT_FOOTER.STATUS_COMMENTS')}
          onSave={handleApprovalBarSave}
          saveDisabled={isEmpty(Documents)}
          disabled={isEmpty(Documents)}
        />
      )}
    </>
  );
}

/**
 * Maps the supplier slice this tab reads.
 * @param {SuppliersDocumentsStoreState} state - Root store state.
 * @returns {StateProps} The mapped props.
 */
const mapStateToProps = ({ SuppliersDetails, UserDetails }: SuppliersDocumentsStoreState): StateProps => {
  const { pendingDocumentType } = SuppliersDetails;
  const { isCompanyAdminLoggedIn, isCompanyUserLoggedIn } = UserDetails;
  return {
    isCompanyAdminLoggedIn,
    pendingDocumentType,
    isCompanyUserLoggedIn,
  };
};

const mapStateToDispatch = {
  deleteDocumentId: deleteDocument,
  fetchUserDocumentsList,
  getAllSupplersDocuments,
  approveRejectDocuments,
  unmountAction,
  getPendingDocumentType,
  getSupplierTemplates,
  fetchSupplierDocTemplates: getSupplierDocTemplates,
  archiveUnarchiveSupplierDocument: archiveUnarchiveDocument,
} as unknown as DispatchProps;

export default connect<StateProps, DispatchProps, OwnProps, SuppliersDocumentsStoreState>(mapStateToProps, mapStateToDispatch)(SuppliersDocuments);
